import { BaseStore } from 'fluxible/addons';
import Actions from '../constants/Actions';

const locales = ['en'];

class IntlStore extends BaseStore {

  static storeName = 'IntlStore';

  static handlers = {};

  constructor(dispatcher) {
    super(dispatcher);
    this.messages = {};
    this.locales = locales;
    this.currentLocale = 'en';
    this.initialNow = Date.now();
  }

  handleLoad({ messages, locale }) {
    this.messages = messages;
    this.currentLocale = locale;
    this.emitChange();
  }

  getMessages() {
    return this.messages;
  }

  getLocales() {
    return this.locales;
  }

  getCurrentLocale() {
    return this.currentLocale;
  }

  getInitialNow() {
    return this.initialNow;
  }

  dehydrate() {
    return {
      currentLocale: this.currentLocale,
      locales: this.locales,
      messages: this.messages,
      initialNow: this.initialNow
    };
  }

  rehydrate({ messages, locales, currentLocale, initialNow }) {
    this.messages = messages;
    this.locales = locales;
    this.currentLocale = currentLocale;
    this.initialNow = initialNow;
  }
}

IntlStore.handlers[Actions.INTL__MESSAGES_LOADED] = 'handleLoad';

export default IntlStore;



// WEBPACK FOOTER //
// ./src/stores/IntlStore.js